module.exports = __webpack_public_path__ + "img/pop_white_R.086a3b35.png";